<template>
  <div class="SalaryPaymentField">
    <div class="label"><span class="required">*</span>{{ label }}</div>
    <div class="value" @click="showDatePicker = true">
      <div v-if="SalaryPaymentField">
        {{ "每月" + SalaryPaymentField + "日" }}
      </div>
      <div v-else style="color: rgba(51, 51, 51, 0.4)">请选择</div>
      <img class="oride-icon" src="@/assets/style/oride-icon.png" alt="" />
    </div>
    <van-popup v-model="showDatePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="dayList"
        @cancel="showDatePicker = false"
        @confirm="onConfirm"
        :default-index="14"
      >
        <template #option="item">
          <div class="custom-option">
            <div class="text-info">
              <div class="name">{{ '每月' + item + '日' }}</div>
            </div>
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { dayList } from "@/utils/const.js";
export default {
  name: "SalaryPaymentField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      SalaryPaymentField: "",
      showDatePicker: false,
      // 快速生成 1号 到 31号 的数组
      dayList: dayList,
    };
  },
  async mounted() {},
  methods: {
    onConfirm(value) {
      this.$emit("input", value);
      this.showDatePicker = false;
    },
  },
  watch: {
    value(newVal) {
      this.SalaryPaymentField = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.SalaryPaymentField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required {
    color: #ff0000;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 33px;
  border-radius: 17px;
  justify-content: space-between;
  padding: 0px 16px;
  background: #f8f8f8;
  font-size: 14px;
  .oride-icon {
    height: 20px;
    margin-left: 10px;
  }
}
.custom-option {
  display: flex;
  align-items: center;
}
.text-info {
  margin-left: 10px;
  font-size: 14px;
}
.dept {
  font-size: 12px;
  color: #969799;
}
</style>
